import React, { Fragment, useEffect, useState } from 'react';
import { TbBowlSpoon, TbCheck, TbCheckupList } from 'react-icons/tb';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { MdOutlineDeliveryDining } from 'react-icons/md';
import { getOrderColorByStatusId } from '../../Utils/Constants/Order';
import { ORDER_STATUS_AWAITING_PAYMENT, ORDER_STATUS_CANCELED, ORDER_STATUS_DONE, ORDER_STATUS_EXPEDITED, ORDER_STATUS_EXPIRED, ORDER_STATUS_MOUNTING, ORDER_STATUS_PENDING, ORDER_STATUS_RELEASED_SHIPMENT, ORDER_STATUS_RELEASED_TAKEAWAY } from '../../Utils/Constants/Checkout';

interface BreadcrumbOrderProps {
    isInDrawer?: boolean;
    order: any;
}

const BreadcrumbOrder = ({ order, isInDrawer }: BreadcrumbOrderProps) => {

    const ping = <div className="animate-ping absolute z-5 rounded-full w-10 h-10 bg-white/20"></div>;
    const { isDelivery } = useOrderTypeContext();
    const [ colorByStatus, setColorByStatus ] = useState<string>('bg-gray-100');
    const [ isDisabled, setIsDisabled ] = useState<boolean>(false);

    interface StepProps {
        name: string;
        description: string;
        icon: any;
    }
    const steps: StepProps[] = [
        { name: 'Montagem', description: 'Preparando', icon: <TbBowlSpoon /> },
        !isDelivery && { name: 'Liberado', description: 'Pronto para entrega', icon: <TbCheckupList /> },
        isDelivery && { name: 'Saiu para entrega', description: 'Falta pouco', icon: <MdOutlineDeliveryDining /> },
        { name: 'Entregue', description: 'Finalizado', icon: <TbCheck /> },
    ].filter(Boolean) as StepProps[]; //* Exibir apenas valores falsy

    const [currentStep, setCurrentStep] = useState<number>(0);
    const checkStatusToChangeStep = (status: number) => {
        switch (status) {
            case ORDER_STATUS_AWAITING_PAYMENT:
                setCurrentStep(0);
                break;
            case ORDER_STATUS_PENDING:
                setCurrentStep(0);
                break;
            case ORDER_STATUS_MOUNTING:
                setCurrentStep(0);
                break;
            case ORDER_STATUS_RELEASED_TAKEAWAY:
            case ORDER_STATUS_RELEASED_SHIPMENT:
                setCurrentStep(1);
                break;
            case ORDER_STATUS_DONE:
                setCurrentStep(2);
                break;
            case ORDER_STATUS_EXPEDITED:
                setCurrentStep(1);
                break;
            default:
                break;
        }
    }


    useEffect(() => {
        if (order.status !== ORDER_STATUS_PENDING) {
            setColorByStatus(`text-white bg-shopfood-${getOrderColorByStatusId(Number(order.status))}`)
        }
        checkStatusToChangeStep(order.status);
        setIsDisabled(Boolean(order && (order.status === ORDER_STATUS_EXPIRED || order.status === ORDER_STATUS_CANCELED)));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [steps, isDelivery, order]);

    const hasStepComplete = (index: number) => {
        return index <= currentStep && order.status !== ORDER_STATUS_PENDING;
    }

    return (
        <div className={`w-full ${isDisabled ? 'grayscale' : ''}`}>
            
            <div className="flex gap-1 md:gap-2 justify-center w-full">
                {steps.map((step: StepProps, index: number) => (

                    <Fragment key={index}>
                        <div className="flex flex-col justify-center items-center gap-2">
                            <div className={`
                                relative flex items-center justify-center rounded-full aspect-square transition-all ease-in-out w-full min-w-16 max-w-16 ${!isInDrawer ? 'md:min-w-20 md:max-w-20' : ''} 
                                ${(index <= currentStep) ? colorByStatus : 'bg-gray-100'}
                            `}>
                                <div className={`text-3xl transition-all ease-in-out ${hasStepComplete(index) ? 'z-10' : 'text-gray-400'}`}>
                                    { step.icon }
                                </div>
                                {(currentStep === index && !isDisabled && order.status !== ORDER_STATUS_DONE) && ping}
                            </div>
                            <div className="flex flex-1 w-full max-w-16 md:max-w-20 self-start sm:break-words h-full font-semibold text-center text-xs md:text-sm lg:text-base justify-center">
                                <span className={`leading-none ${hasStepComplete(index) ? 'text-shopfood-title' : 'text-gray-400'}`}>{ step.name }</span>
                            </div>
                        </div>

                        {index < steps.length - 1 &&
                            <div className='flex-1 min-h-full'>
                                <div className='relative flex items-center justify-center flex-1 min-h-16 max-h-16 md:min-h-20 md:max-h-20'>
                                    <hr className={`w-full h-1.5 leading-none rounded-full shadown-none border-none ${hasStepComplete(index) ? colorByStatus : 'bg-gray-100'}`} />
                                </div>
                            </div>
                        }
                    </Fragment>

                ))}
            </div>
        </div>
    )
}

export default BreadcrumbOrder;